var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"image-viewer-popup"},on:{"click":_vm.closeDialog}},[_c('div',{staticClass:"content"},[_c('div',{attrs:{"id":"close-btn"}},[_vm._v("x")]),_c('img',{attrs:{"src":_vm.imageUrl,"alt":"csepel-foto"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }